import { Section } from '../tools/section';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Selectors
const SELECTOR_CONTAINER = '[data-buildable-image-text]';

const CLASS_ADD_PADDING = 'add-padding';
const CLASS_REMOVE_BG = 'remove-bg';

class BuildableImageText extends Section {
  queryChildren(container: HTMLElement): void {
    this.addPositionClasses();
  }

  attachEvents(): void {
     AOS.init({ duration: 800, easing: 'ease-out', once: true });

    requestAnimationFrame(() => {
      AOS.refreshHard();
    });
  }

  detatchEvents(): void {}

  private addPositionClasses(): void {
    const allBuildableImageTextSections = document.querySelectorAll(SELECTOR_CONTAINER);
    const currentIndex = Array.from(allBuildableImageTextSections).indexOf(this.container);
    
    if (currentIndex === -1) return;
    
    if (currentIndex === allBuildableImageTextSections.length - 1) {
      this.container.classList.add(CLASS_ADD_PADDING);
    }
    
    if (currentIndex % 2 === 1) {
      this.container.classList.add(CLASS_REMOVE_BG);
    }
  }
}

// Register the section
Section.register(SELECTOR_CONTAINER, BuildableImageText);
